var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"organization"},[_c('Title',{attrs:{"title":_vm.title}}),_c('div',{staticClass:"container wow bounceIn",attrs:{"data-wow-offset":"400"}},[_c('img',{attrs:{"src":_vm.column[9]['picurl'],"alt":""}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }